import React from "react";
import "../index.css";

import {Link} from "react-router-dom";
import TableHeader from "../../../../../components/TableHeader/index";
import moment from "moment";
import Pagination from "../../../../../components/Pagination";
import GradeManager from "../../../../../components/Grade";
import {getSchoolYear} from "../../../../../utils/authority";
import StudentController from "../../../../../services/system/student/student-controller";
import ModalSelectClassRoom from "./modalSelectClassRoom";
import Sidebar from "../../../../../components/Sidebar";
import PageHeader from "../../../../../components/PageHeader";
import {toast} from "react-toastify";

class AcceptingTransferStudentManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            gradeId: "GRADE_1",
            showModalSelectClass: false,
            isShowText: false,
            studentIds: [],
            listChecked: [],

            listData: [],
            listClassRoom: [],
            chuaPhanLop: 0,
            pageNumber: 0,
            pageSize: 10,
            page: 0,
            status: "",
            sort: 'id',
            descending: 'DESC',

            currentClassId: -1,
            classRoomId: -1,
            school_name: "",
            code: "",
            ethnic: "",
            fullName: "",
            gender: "",
            grade: "",
            studentState: "CHUA_PHANLOP",
            totalItem: 0,
            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "name",
                    name: "Họ và tên",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "code",
                    name: "Mã học sinh",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "birthday",
                    name: "Ngày sinh",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "sex",
                    name: "Giới tính",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "status",
                    name: "Tiếp nhận từ trường",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "",
                    name: "Chọn",
                    style: {minWidth: 120, textAlign: "center"},
                    sort: false
                }
            ]

        };
    }

    componentDidMount() {
        this.getListPhanLop();
        this.getListStudentChuaPhanLop();
    }

    onUpdateGrade(gradeId) {
        if (gradeId == ""){
            toast.error("Vui lòng chọn khối học");
            this.setState({gradeId: "GRADE_1"}, ()=>{
                this.getListPhanLop()
                this.getListStudentChuaPhanLop()
            })
        }else {
            if (gradeId != this.state.gradeId){
                this.state.classRoomId = -1
                this.setState({gradeId: gradeId}, ()=>{
                    this.getListPhanLop()
                    this.getListStudentChuaPhanLop()
                })
            }
        }
    }
    getListStudent() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            classRoomId: this.state.classRoomId,
            code: this.state.code,
            ethnic: this.state.ethnic,
            fullName: this.state.fullName,
            gender: this.state.gender,
            grade: this.state.gradeId,
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            sort: "created_at desc",
            studentState: this.state.classRoomId<0? "CHUA_PHANLOP": "DANG_HOC",
        };
        StudentController.search(payload, res => {
            this.setState({
                showLoading: false,
                listData: res.data.content,
                totalItem: res.data.totalElements,
                totalPage: Math.round(res.data.totalElements / this.state.pageSize)
            });
        })
    }
    getListStudentChuaPhanLop() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            grade: this.state.gradeId,
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            sort: "created_at desc",
        };
        StudentController.listChuaPhanlop(payload, res => {
            this.setState({
                showLoading: false,
                listData: res.data.content,
                totalItem: res.data.totalElements,
                totalPage: Math.round(res.data.totalElements / this.state.pageSize)
            });
        })
    }
    getListPhanLop() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            grade: this.state.gradeId,
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            sort: "created_at desc",
        };
        StudentController.listPhanlop(payload, res => {
            this.setState({
                showLoading: false,
                listClassRoom: res.data.classRoomPLRes,
                chuaPhanLop: res.data.studentsPL,
                totalItem: res.data.totalElements,
                totalPage: Math.round(res.data.totalElements / this.state.pageSize)
            });
        })
    }
    renderListClass(){
        return this.state.listClassRoom?.map((item, index) =>
            <li>
                <button onClick={this.handleClick.bind(this, item.id)}>
                    {this.state.classRoomId == item.id && <span style={{overflow: "hidden", display: "-webkit-box", padding: 12, backgroundColor: "#57afce", color: "#fff"}}>
                        {item.name}({item.students})
                    </span>}
                    {this.state.classRoomId != item.id && <span style={{overflow: "hidden", display: "-webkit-box", padding: 12, backgroundColor: "#ffff", color: "#57afce"}}>
                        {item.name}({item.students})
                    </span>}
                </button>
            </li>
            )
    }


    handleChangePage = page => {
        this.setState(
            {
                pageNumber: page
            },
            () => {
                if (this.state.classRoomId > -1){
                    this.getListStudent();
                }else {
                    this.getListStudentChuaPhanLop()
                }
            }
        );
    };
    onRefresh() {
        this.state.studentIds = []
        this.state.listChecked = []
        this.getListPhanLop();
        if (this.state.classRoomId > -1){
            this.getListStudent();
        }else {
            this.getListStudentChuaPhanLop()
        }
    }
    handleClick(classRoomId, event) {
        if (this.state.classRoomId != classRoomId){
            this.setState({
                classRoomId: classRoomId,
            }, () =>{
                if (classRoomId < 0){
                    this.getListStudentChuaPhanLop()
                }else {
                    this.getListStudent()
                }
            });
        }
    }

    render() {
        let {listData, header, gradeId, isShowText} = this.state;
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="accept-first-year" parentClass="student-management"/>
                        <div className="mb-4 col-md-10 tab-content">
                            {this.state.showLoading &&
                                <div className="content-loading col-12 ml-3 align-items-center"
                                     style={{display: 'block'}}>
                                    <div className="spinner-grow text-info"/>
                                </div>
                            }
                            <div className="card col-12">
                                <div className='pt-3 mb-4'>
                                    <PageHeader routerEnable={true} isShowLevel={true} title="Phân lớp học sinh đầu cấp"/>
                                    <div className="kt-form kt-form--fit kt-margin-b-20">
                                        <div className="row">
                                            <div className="col-md-12 tab-content with-loading">
                                                {this.state.showLoading &&
                                                    <div className="content-loading col-12 ml-3 align-items-center"
                                                         style={{display: 'block'}}>
                                                        <div className="spinner-grow text-info"/>
                                                    </div>
                                                }
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <div className="mt-6">
                                                        </div>
                                                    </div>
                                                    <div className="col-md-9">
                                                        <div className="pt-3 mb-2">
                                                            <form className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                                                <div className="row">
                                                                    <div className="col-xs-12 col-sm-12 col-md-2 p-0 pr-md-3 d-flex"
                                                                         style={{
                                                                             alignItems: "center",
                                                                             justifyContent: "left"
                                                                         }}>
                                                                        <label className="label-item mb-1 mr-1">Khối</label>
                                                                        <GradeManager
                                                                            isShowText={isShowText}
                                                                            gradeId={gradeId}
                                                                            onUpdateGrade={(gradeId) => this.onUpdateGrade(gradeId)}
                                                                        />
                                                                    </div>
                                                                    {/*<div className="col-xs-12 col-sm-12 col-md-3 p-0 pr-md-3 d-flex">*/}
                                                                    {/*    <label className="label-item col-md-5">Họ tên</label>*/}
                                                                    {/*    <input*/}
                                                                    {/*        placeholder=""*/}
                                                                    {/*        name="Code"*/}
                                                                    {/*        type="text"*/}
                                                                    {/*        className="form-control shadow-none font-14"*/}
                                                                    {/*        style={{width: "100%", height: 35, padding: 8}}*/}
                                                                    {/*        value={this.state.code_temp}*/}
                                                                    {/*        maxLength={50}*/}
                                                                    {/*        onKeyPress={(e) => {*/}
                                                                    {/*            if (e.key === 'Enter') {*/}
                                                                    {/*                this.onhandleSearch()*/}
                                                                    {/*            }*/}
                                                                    {/*        }}*/}
                                                                    {/*        onChange={val =>*/}
                                                                    {/*            this.setState({code_temp: val.target.value.trim()})*/}
                                                                    {/*        }*/}
                                                                    {/*    />*/}
                                                                    {/*</div>*/}
                                                                    <div className="col-xs-12 col-sm-12 col-md-7 p-0 pr-md-3 d-flex"
                                                                         style={{
                                                                             alignItems: "center",
                                                                             justifyContent: "right"
                                                                         }}>

                                                                        <button
                                                                            style={{height: 35, marginLeft: 12}}
                                                                            type="button"
                                                                            className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                                            onClick={() => {
                                                                                if (this.state.studentIds.length > 0){
                                                                                    this.setState({showModalSelectClass: true})
                                                                                }else {
                                                                                    toast.error("Vui lòng chọn học sinh");
                                                                                }
                                                                            }}
                                                                        >
                                                                            Chuyến đến lớp
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </form>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="mt-6">
                                                            <div className="bg-top-class"> Danh sách lớp</div>
                                                            <ul id="student-management" className="content-side-bar-active submenu-y collapse">
                                                                <li>
                                                                    <button onClick={this.handleClick.bind(this, -1)}>
                                                                        {this.state.classRoomId == -1 && <span style={{overflow: "hidden", display: "-webkit-box", padding: 12, backgroundColor: "#57afce", color: "#fff"}}>
                                                                               Chưa phân lớp({this.state.chuaPhanLop})
                                                                        </span>}
                                                                        {this.state.classRoomId != -1 && <span style={{overflow: "hidden", display: "-webkit-box", padding: 12, backgroundColor: "#ffff", color: "#57afce"}}>
                                                                            Chưa phân lớp({this.state.chuaPhanLop})
                                                                         </span>}
                                                                    </button>
                                                                </li>
                                                                {this.renderListClass()}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-9">
                                                        <div className="p-0 mb-3">
                                                            <div className="table-wrapper">
                                                                <table
                                                                    className="table table-striped table-data table-responsive table-bordered">
                                                                    <table className="table">
                                                                        <thead>
                                                                        <TableHeader
                                                                            header={header}
                                                                            clickSort={data => {
                                                                                console.log(data)
                                                                            }}
                                                                        />
                                                                        </thead>
                                                                        {!this.state.listData ||
                                                                        this.state.listData.length == 0 ? (
                                                                            <tbody>
                                                                            <tr>
                                                                                <td colSpan={12}>
                                                                                    <div className="text-center">
                                                                                        Không có dữ liệu
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                            </tbody>
                                                                        ) : (
                                                                            <tbody>
                                                                            {listData &&
                                                                                listData.length > 0 &&
                                                                                listData?.map((row, index) => (
                                                                                    <tr style={{height: 50}}>
                                                                                        <td style={{textAlign: "center"}} scope="row">
                                                                                            {" "}
                                                                                            {this.state.pageNumber * this.state.pageSize +
                                                                                                index +
                                                                                                1}
                                                                                        </td>
                                                                                        <td style={{textAlign: "left"}} scope="row">
                                                                                            {row.fullName}
                                                                                        </td>
                                                                                        <td style={{textAlign: "left"}} scope="row">
                                                                                            {row.code}
                                                                                        </td>
                                                                                        <td style={{textAlign: "left"}} scope="row">
                                                                                            {row.birthday ? moment(row.birthday).format('DD-MM-YYYY') : 'Chưa có dữ liệu'}
                                                                                        </td>
                                                                                        <td style={{textAlign: "center"}}>
                                                                                            {row.gender=="MALE" ? 'Nam' : 'Nữ'}
                                                                                        </td>
                                                                                        <td style={{textAlign: "left"}}>
                                                                                            {row.tiepNhanTuTruong?row.tiepNhanTuTruong:"Chưa có dữ liệu"}
                                                                                        </td>
                                                                                        <td style={{textAlign: "center"}}>
                                                                                            <input
                                                                                                type="checkbox"
                                                                                                checked={this.state.listChecked.length > 0?this.state.listChecked[parseInt(row.id)] : false}
                                                                                                onChange={(e) => {
                                                                                                    let id = parseInt(row.id)
                                                                                                    let isChecked = e.target.checked;
                                                                                                    let pos = this.state.studentIds.indexOf(id)
                                                                                                    if (isChecked){
                                                                                                        if (pos < 0)
                                                                                                            this.state.studentIds.push(id)
                                                                                                    }else {
                                                                                                        if (pos > -1){
                                                                                                            this.state.studentIds.splice(index, 1);
                                                                                                        }
                                                                                                    }
                                                                                                    this.state.listChecked[id] = isChecked
                                                                                                    this.setState(this.state.listChecked)
                                                                                                }}
                                                                                            />
                                                                                        </td>
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        )}
                                                                    </table>
                                                                </table>
                                                            </div>
                                                            <div className="pagination-right">
                                                                <Pagination
                                                                    activePage={this.state.pageNumber}
                                                                    itemsCountPerPage={this.state.pageSize}
                                                                    totalItemsCount={this.state.totalItem}
                                                                    changeHandler={page => this.handleChangePage(page)}
                                                                />
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalSelectClassRoom
                    show={this.state.showModalSelectClass}
                    onHide={() => this.setState({showModalSelectClass: false})}
                    onRefresh={() => this.onRefresh()}
                    id={this.state.studentIds}
                    gradeId={this.state.gradeId}
                />
            </div>
        );
    }
}

export default AcceptingTransferStudentManagement;
